import BaseInteractionService from '@configuratorware/configurator-frontendgui/App/Services/InteractionService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration.js';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import { getConfiguration } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';

export default class InteractionService extends BaseInteractionService {
  async createPdfUrl(
    documentType = 'user',
    configuration = getConfiguration(Services.configurator.state),
    queryParams = {}
  ) {
    const params = { ...Api.getGETParameters(), ...queryParams };
    const customKeys = Object.keys(queryParams);
    const keys = ['_language', '_client', '_channel', '_display_net_prices', '_share_url'];
    const mergedKeys = keys.concat(customKeys);
    const query = new URLSearchParams(location.search);
    let queryString = Object.keys(params)
      .filter((key) => mergedKeys.indexOf(key) !== -1)
      .map((key) =>
        key === '_share_url' ? key + '=' + encodeURIComponent(params[key]) : key + '=' + params[key]
      )
      .join('&');
    if (query.has('_hide_prices')) {
      queryString = queryString.concat('&_hide_prices=' + query.get('_hide_prices'));
    }
    if (query.has('_cta_element')) {
      queryString = queryString.concat('&_cta_element=' + query.get('_cta_element'));
    }
    if (documentType === 'widget') {
      return `${getConf('network.baseURL', '/')}configurations/pdf/${documentType}/${
        configuration.code
      }?${queryString}`;
    }
    return `${getConf('network.baseURL', '/')}configurations/zip/${documentType}/${
      configuration.code
    }?${queryString}`;
  }
}
